// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2J-kW","col":"styles_col__3ois7"};